import { render } from "./MessagesAutomatiquesPage.vue?vue&type=template&id=20adfacd&scoped=true&ts=true"
import script from "./MessagesAutomatiquesPage.vue?vue&type=script&lang=ts"
export * from "./MessagesAutomatiquesPage.vue?vue&type=script&lang=ts"

import "./MessagesAutomatiquesPage.vue?vue&type=style&index=0&id=20adfacd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20adfacd"]])

export default __exports__